<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="px-2 py-1.5" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="chatmigo-audio-chip-shell skip-context-menu rounded-lg p-1 text-inherit"
    />
  </BaseBubble>
</template>
